export default "__VITE_ASSET__CKl5xnRq__"